import type { Item } from '../types';

export function setHighlight(item: Item, on: boolean): void {
  item.el.classList.toggle('highlighted', on);
}
